import { ax } from '@/assets/axios.js';
import { co } from '@/assets/diagnostics.js';
import { decodeBackend } from '@/assets/encode.js';

const ur = {
  /**
   * tests: {
   *  scheduledTestId: { // digital only 
   *    scheduledTest: {},
   *    testdata: {
   *      test_set: {},
   *      resources: [],
   *      questions: [],
   *    },
   *  }
   * }
   */
  tests: {},
  latestTestsetId: 0,
};

export default {
  namespaced: true,
  state() {
    return { ...structuredClone(ur), };
  },
  getters: {
    tests(state) { return state.tests; },
    latestTestsetId(state) { return state.latestTestsetId; },
    currentTest(state) {
      if (state.tests[state.latestTestsetId] == undefined)
        return false;
      return state.tests[state.latestTestsetId];
    },
  },
  actions: {
    fetchTest(context, pl) { // pl: { testSetId: , showanswers?: bool, force?: bool, }

      // only add noanswers if the value is FALSE
      // we want no visible payload if we do hide answers - just in case
      if (pl.showanswers) 
        pl.unsanitized = 1; 

      return new Promise((resolve, reject) => {
        const url = context.rootGetters['auth/loginBaseUrl'];
        ax(url + 'tdata/loadtest', pl).then(
          (response) => {

            const decoded = decodeBackend(response.data);
            let saveData = {
              testSetId: pl.testSetId,
              testSetData: decoded.testset_data,
            }
            context.commit('addTest', saveData);
            resolve();
          },
          (error) => {
            co("error", "fetchTest", error);
            reject(error);
          }
        );
      });
    },
    setLatestTestsetId(context, pl) {
      context.commit("setLatestTestsetId", pl);
    },
    resetAll(context) {
      context.commit('resetAll');
    },
  },
  mutations: {
    addTest(state, pl) {
      state.tests[pl.testSetId] = pl.testSetData;
    },
    setLatestTestsetId(state, pl) {
      state.latestTestsetId = pl;
    },
    resetAll(state) {
      const clone = structuredClone(ur);
      for (const prop in clone) {
        state[prop] = clone[prop];
      }
    },
  },
};
